import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  templateUrl: './confirm.component.html',
})
export class ConfirmComponent {

  @Output() confirmed = new EventEmitter<boolean>();

  @Input() title = 'MESSAGES.CONFIRMATION.EXIT_TITLE';

  @Input() content = 'MESSAGES.CONFIRMATION.CONTINUE';

  @Input() cancel = 'COMMON.BUTTON.NO';

  @Input() confirm = 'COMMON.BUTTON.YES';

  cancelClick() {
    this.confirmed.emit(false);
  }

  acceptClick() {
    this.confirmed.emit(true);
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/confirm/confirm.component.ts